import React from "react";

function Watch() {
  return (
    <div>
      <h1 className="center">watch page</h1>
    </div>
  );
}

export default Watch;
